// French for the PEOPLE zone: contacts on the record and the ghosts the evidence names.
import { registerFr } from '../i18n/index.js';

registerFr({
  'People': 'Personnes',
  '{name} is on the record — open the client record to give them a role.': '{name} figure au dossier — ouvrez la fiche client pour lui attribuer un rôle.',
  '{n} on record': '{n} au dossier',
  '{n} named by the evidence only': '{n} nommé(s) uniquement dans les preuves',
  'Contacts & record': 'Contacts et dossier',
  'No contact on file, and no person named on any event. G0 cannot pass on any engagement until a contact is named for it.': 'Aucun contact enregistré, et aucune personne nommée sur un événement. Le G0 ne peut être franchi pour aucun mandat tant qu’un contact n’y est pas nommé.',
  'sponsor': 'sponsor',
  'Named sponsor for {code} — the answer G0 checks': 'Sponsor nommé pour {code} — la réponse que le G0 vérifie',
  'no role on file': 'aucun rôle enregistré',
  'no email': 'aucun e-mail',
  'not on the record': 'pas au dossier',
  'named on {n} event': 'nommé(e) sur {n} événement',
  'named on {n} events': 'nommé(e) sur {n} événements',
  'no email on the event': 'aucun e-mail sur l’événement',
  'Create a contact from this evidence — the role can be filled in on the record': 'Créer un contact à partir de cette preuve — le rôle pourra être complété dans la fiche',
  'Promoting…': 'Promotion…',
  'Promote to contact': 'Promouvoir en contact',
}, 'ClientPeople');
